import { ContextualInfoButtonWithText } from "@/components/buttons/ContextualInfoButton";
import { getHazardColor, getHazardIcon } from "@/features/branding";
import { anaHazards } from "@/lib/crg_apis/constants/hazards";
import { AnaHazardId } from "@/store/services/facades/types";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
const BACKGROUND_OPACITY = "26"; // 15% opacity in hex
const EXCLUDED_HAZARDS: AnaHazardId[] = ["heat"]; // Heat doesn't damage buildings, and bands are derived from DP.

export interface SignificantHazardsProps {
  incorporatedHz: AnaHazardId[];
  significantHz: AnaHazardId[];
  year?: number;
  noTitle?: boolean;
  tag?: React.ReactNode;
}
export const SignificantHazards = ({
  incorporatedHz,
  significantHz,
  year,
  noTitle = false,
  tag
}: SignificantHazardsProps) => {
  const {
    t
  } = useTranslation("terms");
  const hazardItems = useMemo(() => {
    return incorporatedHz.filter(hz => !EXCLUDED_HAZARDS.includes(hz)).map(hz => ({
      id: hz,
      name: t(`hazards.${anaHazards[hz].newId}`),
      isSignificant: significantHz.includes(hz),
      color: getHazardColor(hz)
    })).sort((a, b) => a.name.localeCompare(b.name));
  }, [incorporatedHz, significantHz]);
  if (hazardItems.length === 0) {
    return null;
  }
  return <div className="w-full @container" data-sentry-component="SignificantHazards" data-sentry-source-file="SignificantHazards.tsx">
      <div className="flex items-start gap-2">
        {!noTitle && <ContextualInfoButtonWithText id="significantHazards" rootClassName=" text-left !font-semibold text-base">
            <span>Significant Hazards {year && `at ${year}`}</span>
          </ContextualInfoButtonWithText>}
        {tag}
      </div>
      <div className="grid grid-cols-1 gap-x-2 gap-y-1 pt-2 @md:grid-cols-2 @xl:grid-cols-3">
        {hazardItems.map(item => {
        const backgroundColor = item.isSignificant ? item.color + BACKGROUND_OPACITY : "transparent";
        return <div key={item.id} title={item.name} className={`flex items-center justify-start gap-1 rounded-md p-0.5 text-start ${item.isSignificant ? "font-semibold text-gray-800" : "text-gray-300 [&_svg]:text-gray-300"}`} style={{
          backgroundColor
        }}>
              <span className="flex-shrink-0">
                {getHazardIcon(item.id, {
              className: item.isSignificant ? "" : "text-gray-300",
              style: item.isSignificant ? {
                color: item.color
              } : undefined
            })}
              </span>
              <span className="min-w-0 truncate">{item.name}</span>
            </div>;
      })}
      </div>
    </div>;
};